import $ from 'jquery';
import jQuery from 'jquery';
import whatInput from 'what-input';

window.$ = $;

window.jQuery = jQuery;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

//add pdf renderer

//import './lib/pdf';
//import './lib/pdf.worker';
//import './lib/viewer';


$(document).foundation();


$(document).ready(function(){

	//console.log(window.location.toString());

	//check to see if a document was loaded automatically, if so highlight the appropriate button
	if (window.location.toString().indexOf('?file=') > -1) {
		//this url contains an autoloaded document, add class to appropriate button
		var pdfFileName = window.location.toString().substring(window.location.toString().indexOf('?file=') + 6)
		$('.pdfDocButtons a').removeClass('activePDF');
		// Disable all tabs
		$('.fundSelectorButtons a').removeClass('activePDF');
		$('.pdfDocButtons').css("display", "none");
		if (pdfFileName.split(".").pop() == "pdf") {
			//this is a PDF
			$('.pdfDocButtons a').each(function() {
				if ($(this).data("pdf") == pdfFileName) {
					$(this).addClass('activePDF');
					// Enables appropriate tab and button
					$(this).parent().css("display", "flex");
					var parentid = $(this).parent().attr('id');
					$('a[data-fundname = '+parentid+']').addClass('activePDF');
					var headName = $('a[data-fundname = '+parentid+']').html();
					$('#fundHeaderName').html(headName);
					
				}
			});
			$('#mainPDFviewer').data('loadedPdf', pdfFileName);
		} else {
			//not a PDF, do nothing for now
		}
	} else {
		//this url doesn't contain an autoloaded document, load the first available if possible
		PDFViewerApplication.open('./assets/pdfs/' + $('.pdfDocButtons a').first().data("pdf"));
		$('#mainPDFviewer').data('loadedPdf', $('.pdfDocButtons a').first().data("pdf"));
	}

	$('.pdfDocButtons a').click(function(event) {
	    //load the PDF in the viewer based on the button clicked
	    //console.log(this);

	    if ($(this).attr('data-pdf')) {
	    	var pdfLink = $(this).data("pdf");
	    	if (pdfLink.split(".").pop() == "pdf") {
		    	//PDFViewerApplication.viewerPrefs.defaultZoomValue = 'page-fit';
		    	PDFViewerApplication.open('assets/pdfs/' + pdfLink);
		    	$('#mainPDFviewer').data('loadedPdf', pdfLink);
		    	$('.pdfDocButtons a').removeClass('activePDF');
		    	$(this).addClass('activePDF');
			} else {
		      	//don't open, this isn't a PDF
		      	//event.preventDefault();
		  	}
		}
	});

	$('.fundSelectorButtons a').click(function(event) {
	    //choose a new set of documents by clicking a fund
	    //console.log($(this).html());
    	$('.fundSelectorButtons a').removeClass('activePDF');
    	$('.pdfDocButtons a').removeClass('activePDF');
    	$(this).addClass('activePDF');
    	$('#fundHeaderName').html($(this).html());

    	$('.pdfDocButtons').hide();
    	$('#' + $(this).data('fundname')).fadeIn();
    	var pdfLink = $('#' + $(this).data('fundname') + ' a').first().data("pdf");
    	PDFViewerApplication.open('./assets/pdfs/' + pdfLink);
    	$('#mainPDFviewer').data('loadedPdf', pdfLink);
    	$('#' + $(this).data('fundname') + ' a').first().addClass('activePDF');

	});

	$(document).on("closeme.zf.reveal", function(e){
	  console.log(e);
	  if (e.target.id == "emailRequest") {
	  	//email was opened
	  	$('#submitEmailRequest_EmailAddress').val('');
	  	$('#emailRequestInputZone').show();
		$('#emailRequestButtonZone').show();
		$('#emailSuccessResponseZone').hide();
	  } else {
	  	//do nothing
	  }
	});

	$('#submitEmailRequest').click(function(event) {
		var emailAddress = $('#submitEmailRequest_EmailAddress').val().trim(); 
		//alert($('#mainPDFviewer').data('loadedPdf'));
		if (validateEmail(emailAddress)) {

			var documentName = $('#mainPDFviewer').data('loadedPdf');
			//var sender = 'info@yorktownfunds.com';
			var receiver = emailAddress; 
			//var emailSubject = 'Email Document Request - Yorktown Funds'; 
			//var fundGroup = 'yorktown'; 
		
			$.ajax({
				url: "../fp_docs_test.php", 
				method: "post", 
				data: { "document":documentName,"sender":sender,"receiver":receiver,"subject":emailSubject,"fundGroup":fundGroup},
				success: function(data){
					//email worked
					$('#emailRequestInputZone').fadeOut();
					$('#emailRequestButtonZone').fadeOut();
					$('#emailSuccessResponse').html('Your email was sent successfully.');
					$('#emailSuccessResponseZone').fadeIn();
				},
				 error: function() {
					//email didn't work
					$('#emailSuccessResponse').html('Sorry, your email was not sent successfully. Double-check the entered email address or try downloading the file using the "download" button.');
					$('#emailSuccessResponseZone').fadeIn();
				} 
			});
		} else {
			alert('Please enter a valid email address.');
		}
	});

});

function validateEmail(email) 
{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}